// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"r8","header":"r9","headline":"r-","closeIcon":"r_","modalCloseIcon":"sa"};